import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Label } from "reactstrap";

import { FormField, CheckFormField, SelectFormField, CustomFormInput } from "../../../../../utils/FormFields";
import Autosuggest from "../../../../AutosuggestCompliance";
import CircularProggress from "../../../../CircularProgress/CircularProgress";
import CustomDropdown from "../../../../CustomDropdown/CustomDropdown";

function PhysicalPersonLegalInfo({
  person,
  onChange,
  personLinks,
  activitySectors,
  publicPositions,
  patrimonies,
  professions,
  autosuggests,
  onChangeAutosuggest,
  disabled,
  errors,
  companyLinks,
  services,
  manual,
}) {
  const fetchSectorSuggestion = (name) =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestSector({ text: name }, (response) => {
        if (response && response.sectors) {
          console.log(response.sectors);
          const suggestions = response.sectors.map((c) => ({
            id: c.Id,
            name: `${c.Description} (${c.Code})`,
          }));
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });

  const onChangeSector = (value) => onChangeAutosuggest("PersonActivitySector", value);

  const handleSelectSector = (id, value) => {
    onChange("PersonActivitySectorId", id, value);
    onChangeSector(value);
  };

  const personPublicPositionId = person.PhysicalPersonPublicPositionId;
  const isPEP = parseInt(personPublicPositionId, 10) > 1;
  const personLinkPositionId = person.PersonLinkPublicPositionId;
  const isPEPRelated = parseInt(personLinkPositionId, 10) > 1;

  return (
    <div>
      {!person.PersonIsMinimal && (
        <div>
          <Row>
            <Col>
              <FormField
                label="Anual Income: "
                disabled={disabled}
                onChange={onChange}
                value={person.PersonAnualIncome}
                name="PersonAnualIncome"
                error={errors.PersonAnualIncome}
                type="number"
                dataTypeDecimalName="currency"
              />
            </Col>
            <Col>
              <FormField
                label="Anual Extra Income: "
                disabled={disabled}
                onChange={onChange}
                value={person.PersonExtraIncomeVolume}
                name="PersonExtraIncomeVolume"
                type="number"
                dataTypeDecimalName="currency"
              />
            </Col>
            <Col>
              {patrimonies ? (
                <SelectFormField
                  label="Patrimony: "
                  disabled={disabled}
                  error={errors.PhysicalPersonPatrimonyId}
                  name="PhysicalPersonPatrimonyId"
                  onChange={onChange}
                  selectItems={patrimonies}
                  getSelectItemId={(i) => i.PatrimonyId}
                  getSelectItemName={(i) => i.PatrimonyDescription}
                  value={person.PhysicalPersonPatrimonyId}
                />
              ) : (
                <CircularProggress sm />
              )}
            </Col>
          </Row>
        </div>
      )}
      {!person.PersonIsMinimal && (
        <div>
          <Row>
            <Col>
              <SelectFormField
                label="Profession: "
                value={person.PersonProfessionId}
                name="PersonProfessionId"
                onChange={onChange}
                selectItems={
                  professions || [
                    {
                      ProfessionId: person.PersonProfessionId,
                      ProfessionName: person.PersonProfessionName,
                    },
                  ]
                }
                getSelectItemId={(profession) => profession.ProfessionId}
                getSelectItemName={(profession) => profession.ProfessionName}
                disabled={disabled}
                error={errors.PersonProfessionId}
              />
            </Col>
            <Col>
              <CustomDropdown
                value={person.PersonActivitySectorId}
                label="Activity Sector: "
                name="PersonActivitySectorId"
                onChange={onChange}
                items={activitySectors}
                getSelectedId={(activitySector) => activitySector.Id}
                getSelectedName={(activitySector) => `${activitySector.Description} - ${activitySector.Code}`}
                getFilterCondition={(activitySector) =>
                  activitySector.Description + " " + activitySector.Code
                }
                disabled={disabled || !manual}
                error={errors.PersonActivitySectorId}
              />
            </Col>
            {/* <Col>
              <SelectFormField
                label="Activity Sector: "
                value={person.PersonActivitySectorId}
                name="PersonActivitySectorId"
                onChange={onChange}
                selectItems={
                  activitySectors || [
                    {
                      Id: person.PersonActivitySectorId,
                      Description: person.PersonActivitySectorName,
                    },
                  ]
                }
                getSelectItemId={(activitySector) => activitySector.Id}
                getSelectItemName={(activitySector) =>
                  `${activitySector.Description} - ${activitySector.Code}`
                }
                disabled={disabled || !manual}
                error={errors.PersonActivitySectorId}
              />
            </Col> */}
            {/* <Col>
              <CustomFormInput label="Activity Sector: " error={errors.PersonActivitySectorId}>
                <Autosuggest
                  value={autosuggests.PersonActivitySector}
                  onChange={onChangeSector}
                  fecthSuggestions={fetchSectorSuggestion}
                  onSelect={handleSelectSector}
                  disabled={disabled || !manual}
                />
              </CustomFormInput>
            </Col> */}
          </Row>
        </div>
      )}
      <SelectFormField
        label="Public Position: "
        value={personPublicPositionId}
        name="PhysicalPersonPublicPositionId"
        onChange={onChange}
        selectItems={
          publicPositions || [
            {
              PublicPositionId: person.PhysicalPersonPublicPositionId,
              PublicPositionName: person.PhysicalPersonPublicPositionName,
            },
          ]
        }
        getSelectItemId={(publicPosition) => publicPosition.PublicPositionId}
        getSelectItemName={(publicPosition) => publicPosition.PublicPositionName}
        disabled={disabled || !manual}
        error={errors.PhysicalPersonPublicPositionId}
        description={isPEP ? "PEP" : undefined}
      />
      {!person.PersonIsMinimal && (
        <div>
          <Row>
            <Col>
              <SelectFormField
                label="Link Person: "
                value={person.PhysicalPersonLinkId}
                name="PhysicalPersonLinkId"
                onChange={onChange}
                selectItems={
                  personLinks || [
                    {
                      PersonLinkId: person.PhysicalPersonLinkId,
                      PersonLinkName: person.PhysicalPersonLinkName,
                    },
                  ]
                }
                getSelectItemId={(personLink) => personLink.PersonLinkId}
                getSelectItemName={(personLink) => personLink.PersonLinkName}
                disabled={disabled || !manual}
                error={errors.PhysicalPersonLinkId}
              />
            </Col>
            <Col>
              <SelectFormField
                label="Link Person Public Position: "
                value={personLinkPositionId}
                name="PersonLinkPublicPositionId"
                onChange={onChange}
                selectItems={
                  publicPositions || [
                    {
                      PublicPositionId: person.PersonLinkPublicPositionId,
                      PublicPositionName: person.PersonLinkPublicPositionName,
                    },
                  ]
                }
                getSelectItemId={(publicPosition) => publicPosition.PublicPositionId}
                getSelectItemName={(publicPosition) => publicPosition.PublicPositionName}
                disabled={disabled || !manual}
                error={errors.PersonLinkPublicPositionId}
                description={isPEPRelated ? "PEP Related" : undefined}
              />
            </Col>
          </Row>
        </div>
      )}
      {!person.PersonIsMinimal && (
        <div>
          <FormField
            label="Institution: "
            value={person.PhysicalPersonInstitution}
            name="PhysicalPersonInstitution"
            onChange={onChange}
            disabled={disabled || !manual}
            error={errors.PhysicalPersonInstitution}
          />
          <div>
            <Label
              style={{
                fontWeight: 500,
                fontSize: "15px",
                color: "black",
                paddingRight: "10px",
              }}
            >
              {"Web User: "}
            </Label>
            <input
              value={person.PhysicalPersonWebUser}
              type="checkbox"
              onChange={(e) => onChange("PhysicalPersonWebUser", e.target.checked)}
              disabled={disabled}
              checked={person.PhysicalPersonWebUser}
            />
          </div>

          {companyLinks ? (
            <SelectFormField
              label="Company Link: "
              value={person.PersonCompanyLinkId}
              name="PersonCompanyLinkId"
              onChange={onChange}
              selectItems={companyLinks}
              getSelectItemId={(i) => i.CompanyLinkId}
              getSelectItemName={(i) => i.CompanyLinkName}
              error={errors.PersonCompanyLinkId}
              disabled={disabled}
            />
          ) : (
            <CircularProggress sm />
          )}
          <Row>
            <Col>
              <FormField
                label="Work History Activities: "
                name="PhysicalPersonWorkHistoryActivities"
                error={errors.PhysicalPersonWorkHistoryActivities}
                onChange={onChange}
                disabled={disabled}
                value={person.PhysicalPersonWorkHistoryActivities}
              />
            </Col>
            <Col>
              <FormField
                label="Work History Years: "
                name="PhysicalPersonWorkHistoryYears"
                error={errors.PhysicalPersonWorkHistoryYears}
                onChange={onChange}
                disabled={disabled}
                value={person.PhysicalPersonWorkHistoryYears}
                type="number"
                decimalScale ={0}
                thousandSeparator = {false}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormField
                label="Work History Relevant Position: "
                name="PhysicalPersonWorkHistoryRelevantPosition"
                error={errors.PhysicalPersonWorkHistoryRelevantPosition}
                onChange={onChange}
                disabled={disabled}
                value={person.PhysicalPersonWorkHistoryRelevantPosition}
              />
            </Col>
            <Col>
              <FormField
                label="Work History Income: "
                name="PhysicalPersonWorkHistoryIncome"
                error={errors.PhysicalPersonWorkHistoryIncome}
                onChange={onChange}
                disabled={disabled}
                value={person.PhysicalPersonWorkHistoryIncome}
                type="number"
                dataTypeDecimalName="currency"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormField
                label="Observations: "
                name="PersonObservations"
                //error={errors.PersonObservations}
                onChange={onChange}
                disabled={disabled}
                value={person.PersonObservations}
              />
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}

PhysicalPersonLegalInfo.propTypes = {
  person: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  personLinks: PropTypes.array,
  publicPositions: PropTypes.array,
  professions: PropTypes.array,
  autosuggests: PropTypes.object.isRequired,
  onChangeAutosuggest: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  companyLinks: PropTypes.array,
  patrimonies: PropTypes.array,
  services: PropTypes.object.isRequired,
};

PhysicalPersonLegalInfo.defaultProps = {
  personLinks: undefined,
  publicPositions: undefined,
  companyLinks: undefined,
  patrimonies: undefined,
  professions: undefined,
};

export default PhysicalPersonLegalInfo;
